<template>
  <Aside
    :toggle-by="toggleBy"
    @oncancel="OnCancel"
    cancel-text="Cancel"
    width="1024px"
  >
    <ItemUpdate
      v-if="toggleBy"
      :title="title"
      :uuid="uuid"
      @onsave="OnSave"
      @oncancel="OnCancel"
      cancel-text="Cancel"
      :item-def="itemDef"
    />
  </Aside>
</template>
<script>
import { Util } from "@/helpers/utilities";
import ItemUpdate from "@/components/ui/item/ItemUpdate.vue";
import Aside from "@/components/ui/Aside.vue";
export default {
  components: {
    ItemUpdate,
    Aside,
  },
  props: {
    toggleBy: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Add Item",
    },
    itemDef: {
      type: Object,
    },
  },
  emits: ["onsave", "oncancel"],
  setup(_, { emit }) {
    const OnSave = () => {
      emit("onsave");
    };
    const OnCancel = () => {
      emit("oncancel");
    };
    return {
      Util,
      OnSave,
      OnCancel,
    };
  },
};
</script>